import styled from 'styled-components';

import LocalStorageHelper from '../../../Utilities/Helpers/LocalStorageHelper';

import { StaticDisplayText } from '../../../Constants/StaticDisplayTexts';

import { Card } from "@mui/material";

export const WebFooterContainer: any = styled.div<{
    $darkMode?: boolean;
}>`
    width: 100%;
    // height: 4.5vh;
    padding: 20px 0px;
    margin-top: auto;
    background:  ${(props) => props.$darkMode ? '#4d5055' : '#f6f8fa'} !important;

    .footerContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        margin: 0px auto;
        flex-direction: row;
        padding: 0px 24px;

        .copyRightContainer {
            color: var(--copyRightTextColor);
            font-size: 13px;
            line-height: 1;
            font-weight: 400;
        }

        .poweredByContainer {
            color: var(--copyRightTextColor);
            font-size: 13px;
            line-height: 1;
            margin-left: auto;

            a {
                color: var(--subTextPrimaryColor) !important; 
                font-weight: 500;
                text-decoration: underlined;
                margin: 0px;

                &:hover {
                    color: var(--textInfoColor) !important;
                }
            }
        }
    }
`;


const Footer = () => {
    //Variables
    let isDarkMode = LocalStorageHelper.isDarkMode();
    const selectedPagePath = window.location.pathname;

    // Event Handlers

    //Render Functions
    return <WebFooterContainer $darkMode={isDarkMode}>
        <div className="footerContent">
            <span className="copyRightContainer">{StaticDisplayText.COPYRIGHTS}</span>
            <div className="poweredByContainer">{StaticDisplayText.POWERED_BY}</div>
        </div>
    </WebFooterContainer>
}

export default Footer;
